import DashboardNav from "./ChildrenStatic/DashboardNav/DashboardNav";
import DashboardRoutes from "./ChildrenRoutes/DashboardRoutes";
// import skuProfitIcon from '../../../assets/images/SkuProfit_Icon_white.png';
// import skuProfitLogo from '../../../assets/images/SkuProfi_Iogo_blue_crop.png';
import soLogo from "../../../assets/images/silveronyx-logo.png";
import soLogoText from "../../../assets/images/silveronyx-logo-text.png";
import "./Dashboard.css";

const Dashboard = () => {
  return (
    <div id="dashboard-container">
      <header>
        <section id="header-left">
          <div id="logo-box">
            <img
              className="header-left--logo"
              src={soLogo}
              alt="SilverOnyx Icon"
            />
          </div>
          <img
            className="header-left--logo-text"
            src={soLogoText}
            alt="SilverOnyx text"
          />
        </section>
        {/* <section id='header-right'>
                    <h2>Signed in as: <span>{user.username}</span></h2>
                    <button className='header-logout-button' onClick={handleLogout}>LOGOUT</button>
                </section> */}
      </header>
      <DashboardNav />
      <DashboardRoutes />
    </div>
  );
};

export default Dashboard;
